import { SiteActionTypes } from './types';
import { action } from 'typesafe-actions';

export const getSiteAppsStart = () =>
  action(SiteActionTypes.GET_SITE_APPS_START);
export const getSiteAppsSuccess = (payload: any) =>
  action(SiteActionTypes.GET_SITE_APPS_SUCCESS, payload);
export const getSiteAppsFailure = (error: string) =>
  action(SiteActionTypes.GET_SITE_APPS_FAILURE, error);
